export default __webpack_public_path__ + "static/media/react.462a4f7c.png";